import React from "react";
import * as Yup from "yup";
import yupSchema from "../../../constants/schema";
import { useErrorHandler } from "../../../hooks";
import DialogFormBuilder from "../../../components/dialog-form-builder";
import mainPageService from "../../../services/main-page.service";
import { Grid } from "@material-ui/core";

const initialValues = {
    title: "",
    destinationURL: "",
    image: "",
    moreButton: [],
    type: "fullCard",
};

const schema = Yup.object().shape({
    destinationURL: yupSchema.destinationURL,
    image: yupSchema.image,
    moreButton: yupSchema.moreButton,
});

const rowTypes = [
    { value: "fullCard", title: "کارت کامل" },
    { value: "4cart", title: "۴ کارت" },
    { value: "2cart", title: "۲ کارت" },
    { value: "selectGlasses", title: "انتخاب عینک" },
    { value: "selectBrands", title: "انتخاب برند" },
    { value: "scrollCards", title: "کارت‌های اسکرولی" },
    { value: "userComments", title: "نظرات کاربران" },
];

const form = [
    {
        _type: "textField",
        name: "title",
        label: "عنوان",
        autoFocus: true,
    },
    {
        _type: "textField",
        name: "destinationURL",
        label: "آدرس مقصد",
    },
    {
        _type: "filePicker",
        name: "image",
        label: "عکس",
        isImage: true,
    },

    {
        _type: "array",
        _wrapper: (props) => <Grid item xs={12} {...props} />,
        _itemsWrapper: (props) => (
            <Grid item xs>
                <Grid container spacing={2} {...props} />
            </Grid>
        ),
        name: "moreButton",
        label: "دکمه های بیشتر",
        dense: true,
        minLength: 1,
        emptyValue: {
            title: '',
            href: '',
        },
        items: [
            {
                _type: "textField",
                _wrapper: (props) => <Grid item xs={12} sm={6} {...props} />,
                name: "title",
                label: "عنوان",
                autoFocus: true,
            },
            {
                _type: "textField",
                _wrapper: (props) => <Grid item xs={12} sm={6} {...props} />,
                name: "href",
                label: "آدرس مقصد",
            }
        ],
    },
];

export default function FormModalContent({ close, data, type, name = "ردیف خانه", hasMoreButton = false }) {

    const errorHandler = useErrorHandler();
    const formType = data?.type || type || "fullCard";

    const handleSubmit = async (model, { setSubmitting }) => {
        // Keep a visually empty title compatible with older backend deployments
        // that still reject an empty string at validation/database level.
        if (!model.title?.trim()) model.title = " ";
        model.otherInfo = {
            moreButton: model.moreButton
        }
        let op;
        const selectedType = data?.type || type || model.type || "fullCard";
        if (data?.id) {
            // Row type is immutable; omitting it also keeps edits compatible with
            // older API deployments that only know the legacy enum values.
            const updateModel = { ...model };
            delete updateModel.type;
            op = await mainPageService.editMainPage(data.id, updateModel);
        } else {
            op = await mainPageService.createMainPage({ ...model, type: selectedType });
        }
        const { error } = op;
        setSubmitting(false);
        if (error) return errorHandler(error);

        close(true);
    };

    return (
        <DialogFormBuilder
            {...{
                close,
                name: name,
                data,
                schema,
                initialValues,
                handleSubmit,
                form: [
                    ...(!data?.id && !type ? [{ _type: "autocomplete", name: "type", label: "نوع", options: rowTypes, valueSelector: "value", labelSelector: "title", disableClearable: true }] : []),
                    ...form.filter(item => {
                        if (item.name === "moreButton") return hasMoreButton && formType === "fullCard";
                        if (["destinationURL", "image"].includes(item.name)) return formType === "fullCard" || formType === "slide";
                        return true;
                    }),
                ],
            }}
        />
    );
}
